import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      title: "1. Post your Reel",
      description: "Create and post your product reel on Instagram or Facebook. No extra steps needed.",
      image: "/assets/revamp/how-it-works/Post your Reel.png"
    },
    {
      title: "2. AI Replies Instantly",
      description: "ReelTale AI detects buying intent in comments and automatically sends product details via DM.",
      image: "/assets/revamp/how-it-works/ReelTale replies instantly.png"
    },
    {
      title: "3. Buyer Gets Product",
      description: "Customers buy directly in the DM with swipeable cards and instant UPI/Card payments.",
      image: "/assets/revamp/how-it-works/Buyer gets product in DM.png"
    },
    {
      title: "4. You Ship, We Update",
      description: "Manage orders and generate shipping labels. We keep your customers updated automatically.",
      image: "/assets/revamp/how-it-works/You ship. We update.png"
    }
  ];

  return (
    <section id="how-it-works" className="py-20 lg:py-24 bg-white dark:bg-gray-900 transition-colors duration-300 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-black text-gray-900 dark:text-white mb-6">See how it works</h2>
          <p className="text-lg text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">Transform your social engagement into revenue in three simple steps.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              <div className="bg-gray-50 dark:bg-gray-800/40 p-8 lg:p-10 rounded-[2.5rem] border border-gray-100 dark:border-gray-700 transition-all duration-500 group-hover:border-purple-500/50 group-hover:shadow-2xl group-hover:shadow-purple-500/10 group-hover:-translate-y-2 h-full">
                {/* Step Number Badge */}
                <div className="absolute -top-3 -left-3 w-10 h-10 bg-purple-600 text-white rounded-xl flex items-center justify-center font-black text-lg shadow-lg shadow-purple-600/30 z-10">
                  {index + 1}
                </div>
                
                <div className="mb-6 overflow-hidden rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm group-hover:shadow-md transition-all duration-500">
                  <img src={step.image} alt={step.title} className="w-full h-40 object-cover transform transition-transform group-hover:scale-110 duration-700" />
                </div>
                
                <h3 className="text-xl font-black text-gray-900 dark:text-white mb-4 leading-tight">
                  {step.title.split('. ')[1]}
                </h3>
                
                <p className="text-base text-gray-500 dark:text-gray-400 leading-relaxed font-medium">
                  {step.description}
                </p>
              </div>
              
              {/* Connector Arrow for Desktop */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-6 transform -translate-y-1/2 z-20">
                  <svg className="w-12 h-12 text-gray-200 dark:text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
